import { Box } from '@material-ui/core';
import { formatMoney, PayoutSummary } from '@nemuru-eng/js-api-client';

import { PayoutSummaryConditionsTable } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/components/PayoutSummaryConditionsTable/PayoutSummaryConditionsTable';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

interface PayoutSummaryDetailsProps {
  payoutSummary: PayoutSummary;
}

export const PayoutSummaryDetails = ({ payoutSummary }: PayoutSummaryDetailsProps) => {
  return (
    <CustomPaper fill="paper">
      <Box display="flex" flexDirection="column" alignItems="flex-start" gridGap={4}>
        <Font variant="overline" color="textSecondary">
          <Text tId={'PAYOUT'} />
        </Font>
        <Font variant={'h2'} color={'title'}>
          {formatMoney(amountToValueMoneyMapper(payoutSummary.disbursedAmount))}
        </Font>
      </Box>
      <Box pb={1}>
        <PayoutSummaryConditionsTable payoutSummary={payoutSummary} />
      </Box>
    </CustomPaper>
  );
};
